import { render, staticRenderFns } from "./HubLoading.vue?vue&type=template&id=6d848444&scoped=true&"
import script from "./HubLoading.vue?vue&type=script&lang=ts&"
export * from "./HubLoading.vue?vue&type=script&lang=ts&"
import style0 from "./HubLoading.vue?vue&type=style&index=0&id=6d848444&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d848444",
  null
  
)

export default component.exports